








import MPopup from '../../index';
import Vue from 'vue';
import Component from 'vue-class-component';

import Button from '@/packages/d-button';

Vue.use(Button);
Vue.use(MPopup);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  public show = true;
}
